<template>
  <sui-segment>
    <h2 class="sui-header" color="red" align="center">{{$t('mainTitle')}}</h2>
    <sui-tab :menu="{ vertical: true, fluid: true}">
      <sui-tab-pane :title="$t('cat1Label')">
        <Zugangskarten />
      </sui-tab-pane>
      <sui-tab-pane :title="$t('cat2Label')">
        <Zugangsprobleme />
      </sui-tab-pane>
      <sui-tab-pane :title="$t('cat3Label')">
        <Verschiedenes />
      </sui-tab-pane>
    </sui-tab>
  </sui-segment>
</template>

<script>
  import Zugangskarten from '@/views/Tab/Zugangskarten.vue'
  import Zugangsprobleme from '@/views/Tab/Zugangsprobleme.vue'
  import Verschiedenes from '@/views/Tab/Verschiedenes.vue'

  export default {
    name: 'Home',
    components: {
      Zugangskarten,
      Zugangsprobleme,
      Verschiedenes
    },
    data() {
      return {

      }
    },
  }
</script>

<style lang="scss" scoped>
</style>
